import React, { useEffect, useRef, useState } from "react";
import ImageWMS from "ol/source/ImageWMS";
import { useTranslation } from "react-i18next";
import LayerFilterMin from "../LayerFilterMin/LayerFilterMin";
import MetaLink from "../MetaLink/MetaLink";
import ShapeLink from "../ShapeLink/ShapeLink";
import { ServerTypeHelper } from "../../../../_config/helpers";
import "./LayerFolder.css";
import LayerSLDWindow from "../LayerSLDWindow/LayerSLDWindow";

const LayerFolder = (props) => {
 
  const { t } = useTranslation();

  const content = useRef();

  const titleUnicode = useRef();

  const [toggle, setToggle] = useState(props.inline);

  let globalZCounter = 1000;


  const hasVisibleLayerInFolder = () => {
  return props.map
    .getLayers()
    .getArray()
    .some(
      (layer) =>
        layer.get("folderSequence") === props.folderSequence &&
        layer.getVisible()
    );
};

  const clientWidth = document.documentElement.clientWidth;

  const clientHeight = document.documentElement.clientHeight;

 useEffect(() => {
  if (!props.sidebarVisible || !content.current) return;

  if (hasVisibleLayerInFolder()) {
    content.current.style.visibility = "visible";
    content.current.style.display = "inherit";
    content.current.style.opacity = "1";
    setToggle(true);
  }
}, [props.sidebarVisible]);

  const handleLayerClick = (event) => {
    const layerId = event.target.value;
    const layer = props.map.getLayers().getArray()[layerId];

  

    layer.setVisible(!layer.getVisible());

    if (layer.getVisible()) 
      props.hasNewVisibleLayer(layerId);
    else 
      props.hasNewVisibleLayer(-layerId);

    let label = document.querySelector(`#layerTitle${layerId}`);

    label.style.animation = "none";

    handleLayerZIndexer(layer);

    handleLayerZoomFocus(layer);

    if (clientWidth <= 900) handleGetLegendGraphic(layer, layerId);
  };

  const handleGetLegendGraphic = (layer, index) => {
 
    if (
      layer.getVisible() &&
      (layer.get("serverType") === ServerTypeHelper.GEOSERVER ||
        layer.get("serverType") === ServerTypeHelper.MAPSERVER)
    ) {
      const wmsSource = new ImageWMS({
        url: layer.get("url"),
        params: { LAYERS: layer.get("wmsName") },
        ratio: 1,
        serverType: layer.get("serverType"),
      });

      const graphicUrl = wmsSource.getLegendUrl(
        props.map.getView().getResolution(),
        { legend_options: "bgColor:#212835;fontColor:#FFFFFF;forceLabels:on;" }
      );
      const img = document.getElementById("layerLegend" + index);
      const legendTitle = document.getElementById("layerLegendTitle" + index);
      img.src = graphicUrl;
      img.onclick = () => window.open(graphicUrl, "_blank").focus();
      img.style.visibility = "visible";
      img.style.display = "inherit";
      img.style.cursor = "pointer";
      legendTitle.style.visibility = "visible";
      legendTitle.style.display = "inherit";
    } else if (!layer.getVisible()) {
      const legendTitle = document.getElementById("layerLegendTitle" + index);
      const img = document.getElementById("layerLegend" + index);
      img.style.visibility = "hidden";
      img.style.display = "none";
      legendTitle.style.visibility = "hidden";
      legendTitle.style.display = "none";
    }
  };

  const handleFolderClick = () => {
    if (toggle) {
      content.current.style.visibility = "hidden";

      content.current.style.display = "none";

      content.current.style.opacity = "0";

      setToggle(false);
    } else {
      content.current.style.visibility = "visible";

      content.current.style.display = "inherit";

      content.current.style.opacity = "1";

      setToggle(true);
    }
  };

  const handleLayerZIndexer = (layer) => {
  const all = props.map.getLayers().getArray();
  const vector           = all[all.length - 4];
  const vectorForCSV     = all[all.length - 3];
  const vectorForGeolocation = all[all.length - 2];
  const graticule        = all[all.length - 1];

  if (layer.getVisible()) {
    globalZCounter += 1;
    layer.setZIndex(globalZCounter);
    vector.setZIndex(globalZCounter + 1);
    vectorForCSV.setZIndex(globalZCounter + 2);
    vectorForGeolocation.setZIndex(globalZCounter + 3);
    graticule.setZIndex(globalZCounter + 4);
  }
};
  const isScoped = () => {
    let layerFolderImage = document.querySelector(
      `#folder${props.folderIndex}image`
    );

    layerFolderImage.style.animation = "none";

    if (content.current.style.visibility === `visible`) {
      setToggle(true);
    } else {
      setToggle(false);
    }
  };

   const handleLayerZoomFocus = async (layer) => {

    let str = layer.get('bbox');

    let regex = /[-\d]{1,}.[\d]{1,}/g;

    let extent = str.match(regex);

    if (extent && extent[0] && extent[1] && extent[2] && extent[3]) {
      try {
        extent = extent.map((e) => parseFloat(e));

        props.map.getView().fit(extent, props.map.getSize());
      } catch (e) {
        console.log(e)
      }
    }

  }



  return (
    <div
      onMouseOver={isScoped}
      className="LayerFolder"
      id={`folder${props.folderIndex}`}
    >
      <h3 className="LayerFolderTitle" onClick={handleFolderClick}>
        <span className="LayerFolderTitleIcon" ref={titleUnicode}>
          <i
            id={`folder${props.folderIndex}image`}
            className={`pi ${toggle ? "pi-folder-open" : "pi pi-folder"}`}
            alt={t(`folder.alt`)}
          />
        </span>
        <span className="LayerFolderTitleText">{t(props.title)}</span>
      </h3>
      <div ref={content} className="content">
        {props.map
          .getLayers()
          .getArray()
          .map((layer, index) =>
            layer.get("folderSequence") === props.folderSequence ? (
              <div className="LayerFolderItem" key={index}>
                <div className="LayerInputContainer">
                  <div className="LayerCheckContainer">
                    <input
                      className="LayerCheck form-check-input"
                      type="checkbox"
                      defaultChecked={
                        layer.getVisible() && layer.get("title") !== "Grade"
                      }
                      id={"layer" + index}
                      value={index}
                      onClick={handleLayerClick}
                    />
                  </div>

                  <div className="LayerTitleContainer">
                    <span className="LayerTitle" id={"layerTitle" + index}>
                      {t(layer.get("title"))}
                    </span>
                  </div>
                </div>

                <div className="LayerActions" key={"LayerActions" + index}>
                  {/* <MetaLink wmsName={layer.get("wmsName")} />
                  <ShapeLink wmsName={layer.get("wmsName")} /> */}

                  <LayerFilterMin
                    map={props.map}
                    layer={layer}
                    wmsName={layer.get("wmsName")}
                  />

                  <LayerSLDWindow
                    map={props.map}
                    layer={layer}
                    wmsName={layer.get("wmsName")}
                    activeVisible={props.activeVisible}
                  />

                  {clientWidth <= 900 || clientHeight <= 750 ? (
                    <>
                      <span
                        id={"layerLegendTitle" + index}
                        className="LayerLegendTitle"
                      >
                        {t(`folder.legend`)}{" "}
                      </span>
                      <img
                        alt="N/A"
                        id={"layerLegend" + index}
                        className="LayerLegend"
                      />
                    </>
                  ) : null}
                </div>
              </div>
            ) : null
          )}
      </div>
    </div>
  );
};

export default LayerFolder;
